import { render, staticRenderFns } from "./editProfile.vue?vue&type=template&id=b13a82ee&scoped=true&"
import script from "./editProfile.vue?vue&type=script&lang=js&"
export * from "./editProfile.vue?vue&type=script&lang=js&"
import style0 from "./editProfile.vue?vue&type=style&index=0&id=b13a82ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13a82ee",
  null
  
)

export default component.exports